import script from "./TableElementsMixin.vue?vue&type=script&lang=js"
export * from "./TableElementsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__